var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-template"},[_c('navigation-segment'),_c('header-segment'),_c('router-view'),_c('footer-segment'),_c('overlay-segment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }